module.exports = __webpack_public_path__ + "static/media/lab.69a9000e.svg";